// Problem-reporter console/error capture — imported FIRST (before App) so the ring buffer
// patches console + window error listeners from app start. Side-effect import only.
import './lib/diagnostics/consoleBuffer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
